var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplunkDark = function SvgSplunkDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#splunk-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60AB31",
    d: "M15 0H5C2.24 0 0 2.24 0 5v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5M5.418 15.48v-2.886l7.158-2.814-7.158-2.784V4.131l10.257 4.435v2.447z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "splunk-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSplunkDark;